import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const fmt = (n) => '£' + Number(n).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

function HeroCard() {
  const income = 55000;
  const tax = 9232;
  const ni = 4580;
  const pension = income * 0.05;
  const takeHome = income - tax - ni - pension;
  const slices = [
    { label: 'Take Home', color: '#4f46e5', pct: (takeHome / income) * 100, val: takeHome },
    { label: 'Income Tax', color: '#818cf8', pct: (tax / income) * 100, val: tax },
    { label: 'NI', color: '#c7d2fe', pct: (ni / income) * 100, val: ni },
    { label: 'Pension', color: '#e0e7ff', pct: (pension / income) * 100, val: pension },
  ];
  return (
    <div className="hero-card">
      <div className="hero-card-label">Take home pay</div>
      <div className="hero-card-amount">
        <span>£</span>{takeHome.toLocaleString('en-GB', { maximumFractionDigits: 0 })}<span style={{ fontSize: '.7em' }}>/yr</span>
      </div>
      <div className="hero-breakdown">
        {slices.map(s => (
          <div key={s.label} className="breakdown-row">
            <div className="breakdown-label">{s.label}</div>
            <div className="breakdown-bar-wrap">
              <div className="breakdown-bar" style={{ width: `${s.pct}%`, background: s.color }} />
            </div>
            <div className="breakdown-val">{fmt(s.val)}</div>
          </div>
        ))}
      </div>
      <div style={{ marginTop: '16px', fontSize: '.75rem', color: 'var(--muted)' }}>
        Based on £55,000 salary · 2025/26
      </div>
    </div>
  );
}

const features = [
  { icon: '⚡', title: 'Instant results', desc: 'No sign-up required. Enter your income and see your breakdown in seconds.' },
  { icon: '🎯', title: 'Pension aware', desc: 'Factor in your pension contributions to see your real take-home pay after deductions.' },
  { icon: '🧾', title: 'Claim back relief', desc: 'Account for work expenses like uniforms, tools, and mileage to reduce your tax bill.' },
];

function HomePage() {
  return (
    <div className="page">
      <Helmet>
        <title>TaxClip — Free UK Income Tax Calculator 2025/26</title>
        <meta name="description" content="Calculate your UK income tax, National Insurance and take-home pay instantly. Free, no sign-up. Includes pension and work expense relief." />
        <link rel="canonical" href="https://taxclip.co.uk/" />
        <meta property="og:title" content="TaxClip — Free UK Income Tax Calculator 2025/26" />
        <meta property="og:description" content="Calculate your UK income tax, National Insurance and take-home pay instantly. Free, no sign-up. Includes pension and work expense relief." />
        <meta property="og:url" content="https://taxclip.co.uk/" />
      </Helmet>
      <div className="hero">
        <div>
          <div className="hero-eyebrow">
            <span className="hero-eyebrow-dot" />
            Free UK tax tools
          </div>
          <h1 className="hero-title">
            Tax doesn't have<br />to be <span>complicated</span>
          </h1>
          <p className="hero-desc">
            Get an instant breakdown of your income tax, National Insurance, pension, and take-home pay. No jargon, no surprises.
          </p>
          <div className="hero-ctas">
            <Link to="/calculator" className="btn-primary">Calculate my tax</Link>
            <Link to="/about" className="btn-ghost">Learn more</Link>
          </div>
        </div>
        <HeroCard />
      </div>

      <div className="features">
        {features.map(f => (
          <div key={f.title} className="feature-card">
            <div className="feature-icon">{f.icon}</div>
            <div className="feature-title">{f.title}</div>
            <div className="feature-desc">{f.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default HomePage;
